import { Badge, Box, Divider, Flex, Heading, HStack } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface IOwnProps {
  title: string;
  subTitle: string;
  badgeText?: string;
  badgeIcon?: ReactNode;
  colorScheme?: string;
  gap?: number;
  px?: number;
}

const CardHeaderMobile: React.FC<IOwnProps> = ({ title, badgeText, badgeIcon, colorScheme, gap, px }) => {
  return (
    <>
      <HStack justify="space-between">
        <Box w="full">
          <Flex align="center" justify="space-between" gap={3}>
            <Heading size="md" whiteSpace="wrap">
              {title}
            </Heading>
            {badgeIcon && badgeText && (
              <Badge
                py={1}
                px={px || 4}
                borderRadius="full"
                textAlign="center"
                fontSize="10px"
                h="fit-content"
                variant="subtle"
                colorScheme={colorScheme}
              >
                <Flex gap={gap || 2}>
                  {badgeIcon}
                  {badgeText}
                </Flex>
              </Badge>
            )}
          </Flex>
          {/* <Text fontSize="0.7rem" color="gray.500" mt={2} dangerouslySetInnerHTML={{ __html: subTitle }} /> */}
        </Box>
      </HStack>
      <Divider borderColor="secondaryColor" />
    </>
  );
};

export default CardHeaderMobile;
